import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './athletics@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="athletics">
    <h1>Athletics</h1>
    <p>
      Kingston offers a comprehensive and challenging PE program that aims to develop a combination of transferable
      skills promoting physical, intellectual, emotional and social development. Our students are encouraged to reflect
      on present and future choices that contribute to long-term healthy living, while learning about and through
      movement. Our balanced curriculum provides students with opportunities to learn through health-related fitness,
      adventure challenges, games, movement composition and individual pursuits.
    </p>
    <p>
      At Kingston, we enjoy collaborating with the local community by holding an annual Terry Fox Run which promotes
      healthy living and cancer awareness. This school-wide fundraiser is an annual event that we use to collect
      donations for oncology departments at local hospitals here in Hong Kong. Kingston also holds a yearly athletics
      competition, Sports Day, where students from all year levels participate in a variety of track and field
      activities and cooperative games.
    </p>
    <p>
      We are very fortunate to have a large playing area for our students, as we have three playgrounds and an indoor
      hall to facilitate our learning in physical education. Our learning experiences are well supported by an abundance
      of high-end, modern PE equipment. The children have access to loads of equipment at their recess time, where they
      are welcome to explore movement or take part in organized games on our larger playground.
    </p>
    <img src={image} alt="Athletics" />
  </ContentLayout>
);
